<template>
  <Borde>
    <b-col
      cols="12"
      lg="5"
      order="2"
      order-lg="1"
      class="py-4 py-lg-5 text-white bg-azul-medio pr-0 pr-lg-3 pl-3 pl-lg-5"
    >
      <b-row class="mx-0">
        <span
          class="col-5 col-lg-12 gilmer text-uppercase d-block font-weight-light pl-0 pl-lg-auto"
        >Postulante</span>
        <span
          class="col-7 col-lg-12 source-sans font-weight-bold pr-0 pl-0 pl-lg-auto mt-0 mt-lg-2"
        >{{nombreCompleto}}</span>
        <span
          class="col-5 col-lg-12 gilmer text-uppercase d-block font-weight-light mt-3 mt-lg-4 pl-0 pl-lg-auto"
        >Curso</span>
        <span
          class="col-7 col-lg-12 source-sans font-weight-bold pr-0 mt-3 mt-lg-0 pl-0 pl-lg-auto mt-3 mt-lg-2"
        >{{nivel}}</span>
      </b-row>
    </b-col>

    <b-col
      order-lg="2"
      class="col-auto w-1px border-right border-azul-claro2 d-none d-lg-block px-0"
    ></b-col>

    <b-col
      cols="12"
      order-lg="3"
      class="h-1px border-top border-azul-claro2 d-block d-lg-none px-0 mt-0"
    ></b-col>

    <b-col
      cols="12"
      lg
      order="1"
      order-lg="4"
      class="d-flex align-items-center justify-content-center py-4 py-lg-5"
    >
      <div class="text-center">
        <FontAwesomeIcon icon="thumbs-up" class="h2 text-success" />
        
        <div v-if="resultado" class="h3 text-success font-weight-bold">Resultado válido</div>
        <div v-else class="h3 text-success font-weight-bold">Postulación válida</div>
        <div class="d-block mt-2 text-black-50">Fecha y hora:</div>
        <div class="d-block text-black-50">{{fechaPostulacion}}</div>
        <slot />
      </div>
    </b-col>
  </Borde>
</template>
<script>
import { library } from "@fortawesome/fontawesome-svg-core";
import { faThumbsUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faThumbsUp);
import Borde from "@/components/generales/postulacion/Borde";
export default {
  props: ["nombreCompleto", "nivel", "fechaPostulacion", "resultado"],
  components: {
    Borde,
    FontAwesomeIcon
  }
};
</script>




// WEBPACK FOOTER //
// src/components/generales/postulacion/Valida.vue